import { Application } from "@hotwired/stimulus";
import { type ControllerConstructor } from "@hotwired/stimulus";
import "@rails/request.js";
import RevealController from "@stimulus-components/reveal";

const application = Application.start();

application.debug = import.meta.env.DEV;

declare global {
  interface Window {
    Stimulus: Application;
  }
}

window.Stimulus = application;

application.register("reveal", RevealController);

const componentModules = import.meta.glob(
  ["../../components/**/component.ts"],
  { eager: true },
);
// We just force Vite to process them, but not actually gonna use them here
import.meta.glob(["../../components/**/component.css"], { eager: true });

const controllerModules = import.meta.glob("~/controllers/*.ts", {
  eager: true,
});

for (const [path, module] of Object.entries(componentModules)) {
  const dirs = path.split("/");

  // Dropping ../../components and component.ts parts
  const name = dirs
    .slice(3, dirs.length - 1)
    .join("-")
    .replaceAll("_", "-")
    .toLocaleLowerCase();

  application.register(
    // @tag stimulus-id
    "ui-cmp-" + name,
    (module as { default: ControllerConstructor }).default,
  );
}

for (const [path, module] of Object.entries(controllerModules)) {
  const dirs = path.split("/");
  const name = dirs[dirs.length - 1]
    .replace("_controller.ts", "")
    .replaceAll("_", "-");
  application.register(
    name.toLocaleLowerCase(),
    (module as { default: ControllerConstructor }).default,
  );
}

export { application };
